import React from 'react';
import moment from 'moment';
import { findIndex } from 'underscore';

class SearchAttrShow extends React.Component {
  constructor(props) {
    super(props);
    this.minRangeValue = null;
    this.maxRangeValue = null;
    this.showSearchItemForTopBar = this.showSearchItemForTopBar.bind(this);
    this.deleteSearch = this.deleteSearch.bind(this);
  }
  deleteSearch(index, item, event) {
    event.preventDefault();
    this.props.deleteSearchAttr(index, item);
  }

  showSearchItemForTopBar(searchItem, index) {
    if (searchItem.key.toString() === 'pagenumber' || searchItem.key.toString() === 'view' || searchItem.key.indexOf('[min]') !== -1 || searchItem.key.indexOf('[start]') !== -1) {
      return false;
    }
    let minValue = null;
    let maxValue = null;
    if (searchItem.key.indexOf('[max]') !== -1) {
      maxValue = searchItem.value;
      const maxKey = searchItem['metakey'] + '[min]';
      const indexOfMin = findIndex(window.searchArray, { key: maxKey });
      if (indexOfMin !== -1) {
        minValue = window.searchArray[indexOfMin].value;
      }
    }
    return (<div key={'searchResult-' + index} className="search-result-selected">
        {searchItem.key.indexOf('[') === -1 ?
          <p className="rq-search-item-single">
            {searchItem.value + '  '}
            <a href="#" className="attrClose" onClick={this.deleteSearch.bind(this, index, searchItem)} >
              <i className="ion-android-close"></i>
            </a>
          </p> : null}
        {searchItem.key.indexOf('[') !== -1 && searchItem.key.indexOf('[max]') !== -1 ?
          <p>
            {minValue} - {maxValue} {' '}
           <a href="#" className="attrClose" onClick={this.deleteSearch.bind(this, index, searchItem)} >
              <i className="ion-android-close"></i>
            </a>
          </p> : null}
          {searchItem.key.indexOf('[') !== -1 && searchItem.key.indexOf('[end]') !== -1 ?
            <p>
              { moment(this.startDateRange).format('ll') + ' '} - {' ' + moment(this.endDateRange).format('ll') } {' '}
             <a href="#" className="attrClose" onClick={this.deleteSearch.bind(this, index, searchItem)} >
                <i className="ion-android-close"></i>
              </a>
            </p> : null}
    </div>);
  }

  render() {
    for (let index = 0; index < window.searchArray.length; index++) {
      const indexOfKeyMin = window.searchArray[index].key.indexOf('[min]');
      if (indexOfKeyMin !== -1) {
        this.minRangeValue = window.searchArray[index].value;
      }
      const indexOfKeyMax = window.searchArray[index].key.indexOf('[max]');
      if (indexOfKeyMax !== -1) {
        this.maxRangeValue = window.searchArray[index].value;
      }
      const indexOfKeyStart = window.searchArray[index].key.indexOf('[start]');
      if (indexOfKeyStart !== -1) {
        this.startDateRange = window.searchArray[index].value;
      }
      const indexOfKeyEnd = window.searchArray[index].key.indexOf('[end]');
      if (indexOfKeyEnd !== -1) {
        this.endDateRange = window.searchArray[index].value;
      }
    }
    return (<div className="search-attribute">
      <p className="result-text"><span>{this.props.results}</span>
        {this.props.results > 1 ? 'results' : 'result'} found</p>
      <div className={ this.props.flag !== null ? 'filter-option' : 'no-filter-option'}>
        <div className="filter-result-item">
          { window.searchArray.length ? window.searchArray.map(this.showSearchItemForTopBar) : null }
        </div>
      </div>
      </div>
    );
  }
}

SearchAttrShow.propTypes = {
  'results': React.PropTypes.node,
  'deleteSearchAttr': React.PropTypes.func,
};

export default SearchAttrShow;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/bar/searchAttribute.js